export const chatDockEn = {
  "cowork.chatDock.title": "Agent chat",
  "cowork.chatDock.close": "Close chat panel",
  "cowork.chatDock.expand": "Expand chat",
  "cowork.chatDock.restore": "Restore side panel",
  "cowork.chatDock.documents": "Work with invoices, receipts, bank statements and other documents.",
  "cowork.chatDock.processing": "Processing",
} as const
export const chatDockEt: Record<keyof typeof chatDockEn, string> = {
  "cowork.chatDock.title": "Vestlus agendiga",
  "cowork.chatDock.close": "Sulge vestluspaneel",
  "cowork.chatDock.expand": "Laienda vestlust",
  "cowork.chatDock.restore": "Taasta külgpaneel",
  "cowork.chatDock.documents": "Tööta arvete, kviitungite, pangaväljavõtete ja muude dokumentidega.",
  "cowork.chatDock.processing": "Töötlemine",
}
export const chatDockRu: Record<keyof typeof chatDockEn, string> = {
  "cowork.chatDock.title": "Чат с агентом",
  "cowork.chatDock.close": "Закрыть панель чата",
  "cowork.chatDock.expand": "Развернуть чат",
  "cowork.chatDock.restore": "Вернуть боковую панель",
  "cowork.chatDock.documents": "Работайте со счетами, чеками, банковскими выписками и другими документами.",
  "cowork.chatDock.processing": "Обработка",
}
